<template>
    <div
        class="w-full bottom-0 z-10 py-1 text-center flex justify-center"
        :class="colorClass"
    >
        <div class="text-subtitle-2 justify-center">
            <span class="flex flex-row">
                <a href="/data" target="_blank">
                    {{ $t("page.ls_page_privacy_policy") }}
                    <span class="px-2"> | </span>
                </a>
                <a href="/agb" target="_blank">
                    {{ $t("page.ls_page_agb") }}
                    <span class="px-2"> | </span>
                </a>
                <a href="/imprint" target="_blank">
                    {{ $t("page.ls_page_imprint") }}
                </a>
            </span>

            <div
                class="flex flex-row justify-center items-center font-normal mt-1 md:mt-0"
            >
                <span>
                    &copy; {{ currentYear }}
                    <span class="mx-1"> {{ appName }}</span>
                </span>
                <span class="flex">
                    <span class="mx-1">&middot;</span>
                    {{ $t("common.footer.made_with") }} &#x1F49A;
                    {{ $t("common.footer.in") }}
                    {{ appLocation }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { APP_CONFIG } from "@/Helpers/constants";
import { usePage } from "@inertiajs/vue3";
import { useGrid } from "vue-screen";
import { computed } from "vue";
const appName = APP_CONFIG.NAME;
const appLocation = APP_CONFIG.LOCATION;
const currentYear = new Date().getFullYear();

const grid = useGrid("tailwind");

const isSettingsPage = computed(
    () =>
        usePage().url.includes("settings") &&
        !usePage().url.includes("billing-info")
);

const colorClass = computed(() => {
    return [
        {
            "text-gray-800 bg-almost-white": isSettingsPage.value && !grid.md,
            "text-white bg-gray-850": grid.md || !isSettingsPage.value,
        },
    ];
});
</script>
